
export default "/assets/plus-micro.a54d0ceb.svg"